// extracted by mini-css-extract-plugin
export default {"sliderSwiper":"swiperBlock_sliderSwiper__DXzz-","swiperSlide":"swiperBlock_swiperSlide__4slVZ"};